var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bars-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }